import { render, staticRenderFns } from "./parentEdit.vue?vue&type=template&id=fcbbd184&scoped=true&"
import script from "./parentEdit.vue?vue&type=script&lang=js&"
export * from "./parentEdit.vue?vue&type=script&lang=js&"
import style0 from "./parentEdit.vue?vue&type=style&index=0&id=fcbbd184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbbd184",
  null
  
)

export default component.exports